import React from 'react'
const UserContext = React.createContext({userdetails:''})
export const UserProvider = UserContext.Provider
export default UserContext